import { apiIsomorphicFetchUserEnvironment } from 'api/userEnvironment/apiFetchUserEnvironment';
import type { LayoutHandleProps } from 'layouts/Layout/LayoutHandleProps';
import { redirectRequireAuthentication } from 'modules/auth/routing/redirect-require-authentication';
import { userDashboardApiIsomorphicFetchGeneralSettings } from 'modules/userDashboard/api/generalSettings/userDashboardApiFetchGeneralSettings';
import type { HorizonAppRouteComponentProps } from 'routing/types/HorizonAppRouteComponentProps';
import type { HorizonLoaderFunctionArgs } from 'routing/types/HorizonLoaderFunctionArgs';

import { UserDashboardSubLayoutLoadable } from './UserDashboardSubLayoutLoadable';

export const handle = {
  darkBackground: true,
  fallbackUrlByLocaleToCurrent: true,
  searchFromPageType: 'DASHBOARD',
  showDesktopSearch: true,
} satisfies LayoutHandleProps;

export async function loader({
  request,
  context,
}: HorizonLoaderFunctionArgs<void>) {
  const { user } = await apiIsomorphicFetchUserEnvironment({
    request,
    context,
  })();

  if (!user) return redirectRequireAuthentication({ request });

  const [generalSettings] = await Promise.all([
    userDashboardApiIsomorphicFetchGeneralSettings({ request, context })(),
    UserDashboardSubLayoutLoadable.load(),
  ]);

  return { generalSettings };
}

export function shouldRevalidate() {
  // Don't revalidate when search params change, as they won't influence this loader
  return false;
}

export default function UserDashboardSubLayoutHorizonRoute({
  loaderData: { generalSettings },
}: HorizonAppRouteComponentProps<typeof loader>) {
  return (
    <UserDashboardSubLayoutLoadable initialGeneralSettings={generalSettings} />
  );
}
